export default "__VITE_ASSET__DGJ6x$_H__"